import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { BolloVirtualePAModalComponent } from './bollo-virtuale-pa-modal';

export const BolloVirtualePAModalModule: string = ng
    .module('bollo-virtuale-pa-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('bolloVirtualePAModalComponent', BolloVirtualePAModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/bollo-virtuale-pa-modal/bollo-virtuale-pa-modal.module.ts